(function() {
    $(document).ready(function() {
        let sRlvApiUrl = '';

        if (window.c24LpDomain === '.check24-test.de') {
            sRlvApiUrl = 'https://ssoactivities.proxy.vorsorge.check24-int.de/risikoleben/last-searches';
        } else {
            sRlvApiUrl = 'https://vorsorge.check24.de/risikoleben/last-searches/';
        }

        const oIpss = $.extend(true, {}, window.c24.lp.ipssReforged);

        oIpss.tilesOrder = [
            'appointments',
            'incompleteContracts',
            'offers',
            'lastSearches',
            'contracts',
            'staticTiles',
            'promotions',
        ];

        oIpss.bCommaAfterPerson = false;
        oIpss.tileHeadlineMap.incompleteContract = 'Ihr Antrag';
        oIpss.tileHeadlineMap.staticTile = 'Persönliche Beratung';

        // tmp headline handling while incompleteContracts and lastSearches only
        // remove when displaying tab navi
        oIpss.renderHeadline = function(data) {
            const self = this;
            let amountHeadline;
            let typeHeadline;
            let amountHeadlineExtend = '';
            const newHeadline = {};
            const $headlineShowEverything = $('[id^="lastSearches"] .ipssHeadline.lastSearches', this.domContext);
            const $tabHeadlineLastSearches = $('.cssTabHeaderItem[data-contentbox^="lastSearches"]', this.domContext);
            const iAmountNonContracts = data.contracts ? data.contracts.length : 0;

            if (!self.isValidApiResponse(data)) {

                newHeadline.general = 'Meine letzte Aktivität';
                newHeadline.lastSearches = 'Meine letzten Vergleiche';
            } else {
                if (data.contracts && iAmountNonContracts > 0) {

                    amountHeadlineExtend = '';
                    if (iAmountNonContracts < 2) {

                        typeHeadline = 'Antrag';
                        amountHeadline = 'Mein ';
                    } else {

                        typeHeadline = 'Anträge';
                        amountHeadline = 'Meine  ';
                    }

                    newHeadline.general = amountHeadline + typeHeadline + amountHeadlineExtend;
                }

                if (data.lastSearches) {

                    typeHeadline = 'Vergleich';

                    if (data.lastSearches.length < 2) {
                        amountHeadline = 'Mein letzter ';
                        amountHeadlineExtend = '';
                    } else {
                        amountHeadline = 'Meine letzten ';
                        amountHeadlineExtend = 'e';
                    }

                    newHeadline.lastSearches = amountHeadline + typeHeadline + amountHeadlineExtend;
                }

                if (self.bUseTilesLayout && self.bIsMobile) {
                    $('.ipssHeadline.activities', self.domContext).text(`Meine Aktivitäten (${data.lastSearches?.length})`);
                    $('.ipssHeadline.nonContracts', self.domContext).text(`Meine Anträge (${iAmountNonContracts})`);
                }
            }

            if (self.bShowContracts) {

                if (iAmountNonContracts < 1 && data.lastSearches) {
                    newHeadline.general = newHeadline.lastSearches;
                    newHeadline.lastSearches = null;
                }

                $tabHeadlineLastSearches.text(newHeadline.general);

                if (newHeadline.lastSearches === null) {
                    $headlineShowEverything.remove();
                } else {
                    $headlineShowEverything.text(newHeadline.lastSearches);
                }

            } else {
                $('[id^="lastSearches"] .ipssHeadline.nonContracts', this.domContext).text(newHeadline.general);
                $headlineShowEverything.text(newHeadline.lastSearches);
            }
        };

        oIpss.handleNonContracts = function() {
            const self = this;

            if (self.bUseTilesLayout && self.bIsMobile) {
                oIpss.handleNonContractsSeparately(self.aNonContractsGrouped);

            } else {
                if (!self.isValidApiResponse(self.aNonContractsGrouped)) {
                    self.showDefaultTeaser(self);

                    self.noExistingNonContracts();

                    if (!self.bShowContracts) {
                        return;
                    }
                } else {
                    self.renderList();
                }

            }

            self.renderHeadline(self.aNonContractsGrouped);
        };

        oIpss.handleNonContractsSeparately = function(data) {
            const self = this;
            const lastSearches = data.lastSearches;
            const contracts = data.contracts;

            if (!self.isValidObjectWithContent(contracts)) {
                self.noExistingNonContracts();
            }
            if (!self.isValidObjectWithContent(lastSearches)) {
                self.noExistingNonContracts();
            }
            self.renderList();

        };


        oIpss.noExistingNonContracts = function() {
            const self = this;
            const $lastSearchesDummyContainer = $('[id^=lastSearches]', self.domContext);
            const $tilesContainer = $('.box24VsIpss', self.domContext);
            const iAmountNonContracts = self.aNonContractsGrouped.contracts ? self.aNonContractsGrouped.contracts.length : 0;
            const iAmountLastSearches = self.aNonContractsGrouped.lastSearches ? self.aNonContractsGrouped.lastSearches.length : 0;

            if (iAmountLastSearches < 1 && iAmountNonContracts < 1) {
                self.bNonContractsExists = false;
            }

            if (iAmountLastSearches < 1) {
                $lastSearchesDummyContainer.children('.ipssHeadline.lastSearches').remove();
                $lastSearchesDummyContainer.children('.ipssItemWrapper.lastSearchesContainer').remove();
                if (self.bUseTilesLayout) {
                    $('.ipssHeadline.activities', self.domContext).remove();
                }
            }

            if (iAmountNonContracts < 1) {
                if (self.bUseTilesLayout && self.bIsMobile) {
                    $tilesContainer.children('.ipssHeadline.nonContracts').remove();
                    $tilesContainer.children('.ipssItemWrapper.nonContractsContainer').remove();
                } else {
                    $lastSearchesDummyContainer.children('.ipssHeadline.nonContracts').remove();
                    $lastSearchesDummyContainer.children('.ipssItemWrapper.nonContractsContainer').remove();
                }

            }
        },


        oIpss.renderDataArrayProductSpecificTileHeadline = function(sRenderType, data) {
            if (sRenderType === 'incompleteContract' && data?.status?.text?.includes('offene Aufgaben')) {
                return 'Offene Aufgaben';
            }

            return false;
        };

        oIpss.renderProductSpecificLabels = function (data, sRenderType) {
            const protectionTypeMapLastSearches = {
                'constant': 'Konstante Versicherungssumme',
                'falling': 'Fallende Versicherungssumme',
            };
            const protectionTypeMapContracts = {
                'constant': 'konstant',
                'falling': 'fallend',
            };
            const dataInputs = data.inputs;
            const labels = {};
            const self = this;

            if (!dataInputs) {
                return labels;
            }

            if (dataInputs.occupation) {
                labels.occupation = dataInputs.occupation;
            } else {
                labels.occupation = null;
            }

            if (!window.c24LpIsMobile && labels.occupation) {
                labels.occupation += ',\xa0';
            }

            if (dataInputs.birthday) {
                labels.birthday = dataInputs.birthday;
            } else {
                labels.birthday = null;
            }

            if (dataInputs.protectionType) {
                if (sRenderType !== 'lastSearches' && window.c24LpIsMobile) {
                    labels.protectionType = protectionTypeMapContracts[dataInputs.protectionType] || null;
                } else {
                    labels.protectionType = protectionTypeMapLastSearches[dataInputs.protectionType] || null;
                }
            } else {
                labels.protectionType = null;
            }

            if (!window.c24LpIsMobile && labels.protectionType && sRenderType === 'lastSearches' && !self.bUseTilesLayout) {
                labels.protectionType += ':\xa0';
            }

            if (dataInputs.insureSum) {
                labels.insureSum = oIpss.formatPrice(dataInputs.insureSum, 'euro', false, oIpss.bPriceInCents, true);

                if (sRenderType === 'lastSearches') {
                    labels.insureSum += '&nbsp;';
                }
            } else {
                labels.insureSum = null;
            }

            if (dataInputs.insurePeriod) {
                let dateSuffix = ' Jahr';

                if (dataInputs.insurePeriod > 1) {
                    dateSuffix += 'e';
                }
                labels.insurePeriod = dataInputs.insurePeriod + dateSuffix;
            } else {
                labels.insurePeriod = null;
            }

            return labels;
        };

        oIpss.renderLinkingDelete = function(element, data) {
            const self = this;

            if (this.bIsMobile && !self.bUseTilesLayout) {
                $('.delete', element).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const jSelf = $(this).parent('.metaData');

                    if (jSelf.data('deletelink')) {
                        self.removeIpssItem(jSelf, self);
                    }

                    return false;
                });

            } else {
                $('.delete', element).on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    const jSelf = $(this);
                    self.removeIpssItem(jSelf, self);

                    return false;
                });
            }

            const metaDataContainer = $('.metaData', element);

            if (data.urlDelete != null) {
                if (this.bIsMobile && !self.bUseTilesLayout) {
                    metaDataContainer.data('deletelink', data.urlDelete);
                } else {
                    if ($('.delete', metaDataContainer).length) {
                        $('.delete', metaDataContainer).data('deletelink', data.urlDelete);
                    } else {
                        $('.delete', element).data('deletelink', data.urlDelete);
                    }
                }
            } else {
                if (this.bIsMobile && !self.bUseTilesLayout) {
                    $('.delete', metaDataContainer).remove();
                } else {
                    if ($('.delete', metaDataContainer).length) {
                        $('.delete', metaDataContainer).remove();
                    } else {
                        $('.delete', element).remove();
                    }
                }
            }
        };

        // oIpss.overrideData = {"version":1,"lastUpdate":1637903600,"lastSearches":[{"time":1641497137,"deviceOutput":"desktop","result":{"cta":{"type":"primary","text":"Vergleich fortsetzen","urlDesktop":"https://vorsorge.check24.de/risikoleben/vergleichsergebnis/?c24api_calculationparameter_id=1e0b44ec7e9fb0030524c6356ca3577a","urlMobile":"https://m.vorsorge.check24.de/risikoleben/vergleichsergebnis/?c24api_calculationparameter_id=1e0b44ec7e9fb0030524c6356ca3577a"},"tariff":{"count":44,"best":{"period":"monthly","price":14.54 }},"inputs":{"occupation":"Softwareentwickler/in","birthday":"04.08.1994","loap":"no","protectionType":"constant","insureSum":200000,"insurePeriod":1 },"urlDelete":"https://vorsorge.check24.de/risikoleben/last-searches/delete/1e0b44ec7e9fb0030524c6356ca3577a"}}, {"time":1641497137,"deviceOutput":"desktop","result":{"cta":{"type":"primary","text":"Vergleich fortsetzen","urlDesktop":"https://vorsorge.check24.de/risikoleben/vergleichsergebnis/?c24api_calculationparameter_id=1e0b44ec7e9fb0030524c6356ca3577a","urlMobile":"https://m.vorsorge.check24.de/risikoleben/vergleichsergebnis/?c24api_calculationparameter_id=1e0b44ec7e9fb0030524c6356ca3577a"},"tariff":{"count":44,"best":{"period":"monthly","price":14.54 }},"inputs":{"occupation":"Softwareentwickler/in","birthday":"01.01.2000","loap":"no","protectionType":"constant","insureSum":200000,"insurePeriod":25 },"urlDelete":"https://vorsorge.check24.de/risikoleben/last-searches/delete/1e0b44ec7e9fb0030524c6356ca3577a"}}],"contracts":[],"deleteAll":{"lastSearches":{"urlDesktop":"delete-all-lastSearches-desktop","urlMobile":"delete-all-lastSearches-mobile"}}};
        oIpss.overrideData = {
            'version': 1,
            'lastUpdate': 1637903600,
            'lastSearches': [
                {
                    'time': 1641497137,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'count': 44,
                            'best': {
                                'period': 'monthly',
                                'price': 14.54,
                            },
                        },
                        'inputs': {
                            'occupation': 'Softwareentwickler/in',
                            'birthday': '04.08.1994',
                            'loap': 'no',
                            'protectionType': 'constant',
                            'insureSum': 200000,
                            'insurePeriod': 1,
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
                {
                    'time': 164984437,
                    'deviceOutput': 'desktop',
                    'result': {
                        'cta': {
                            'type': 'primary',
                            'text': 'Vergleich fortsetzen',
                            'urlDesktop': 'https://urlDesktop',
                            'urlMobile': 'https://urlMobile',
                        },
                        'tariff': {
                            'count': 44,
                            'best': {
                                'period': 'monthly',
                                'price': 14.54,
                            },
                        },
                        'inputs': {
                            'occupation': 'Softwareentwickler/in',
                            'birthday': '01.01.2000',
                            'loap': 'no',
                            'protectionType': 'constant',
                            'insureSum': 200000,
                            'insurePeriod': 25,
                        },
                        'urlDelete': 'https://urlDelete',
                    },
                },
            ],
            'contracts': [
                {
                    'time': 1574784512,
                    'type': 'incompleteContract',
                    'publicId': 'RLV-10713517',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'jetzt online abschließen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                        {
                            'type': 'secondary',
                            'text': 'Neu vergleichen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'tariff': {
                        'name': 'Spar',
                        'period': 'monthly',
                        'price': 5.13,
                    },
                    'insuranceKey': 'hannoversche_leben',
                    'status': {
                        'text': 'dummy status',
                        'color': 'yellow',
                    },
                    'servicesRating': null,
                    'info': null,
                    'inputs': {
                        'insureSum': 100000,
                        'insurePeriod': 20,
                        'protectionType': 'constant',
                        'persons': [
                            {
                                'firstName': 'Max',
                                'lastName': 'Pecu',
                            },
                        ],
                    },
                    'urlDelete': 'https://urlDelete',
                },
                {
                    'time': 1574784512,
                    'type': 'contract',
                    'publicId': 'RLV-10713517',
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'testtest',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                        {
                            'type': 'secondary',
                            'text': 'Neu vergleichen',
                            'urlDesktop': 'URL',
                            'urlMobile': 'URL',
                        },
                    ],
                    'tariff': {
                        'period': 'monthly',
                        'price': 5.13,
                    },
                    'insuranceKey': 'hannoversche_leben',
                    'status': {
                        'text': 'dummy status',
                        'color': 'yellow',
                    },
                    'servicesRating': null,
                    'info': null,
                    'inputs': {
                        'insureSum': 100000,
                        'insurePeriod': 20,
                        'protectionType': 'constant',
                        'persons': [
                            {
                                'firstName': 'Max',
                                'lastName': 'Pecu',
                            },
                        ],
                    },
                    'urlDelete': 'https://urlDelete',
                },
            ],
            'staticTiles': [
                {
                    'message': {
                        'persons': [
                            {
                                'gender': 'male',
                                'firstName': 'Hans',
                                'lastName': 'Mustermann',
                            },
                        ],
                        'salutation': 'Hallo',
                    },
                    'consultant': {
                        'persons': [
                            {
                                'firstName': 'Paul',
                                'lastName': 'Beermann',
                            },
                        ],
                        'image': {
                            'urlDesktop': 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/7.png',
                            'urlMobile': {
                                'default': 'https://dummyimage.com/100/ff0000/000000.jpg',
                                'highRes': 'https://dummyimage.com/200/008000/c3c3c3.jpg',
                            },
                            'urlApp': 'https://dummyimage.com/100/ffa500/000000.jpg',
                            'urlTabletApp': 'https://dummyimage.com/100/800080/fff.jpg',
                        },
                    },
                    'urlDelete': 'https://delete static tile URL',
                },
            ],
            'promotions': [
                {
                    'headline': {
                        'text': '100 € Cashback',
                    },
                    'inputs': {
                        'image': {
                            'urlDesktop': 'https://dummyimage.com/100/ff0000/000000.jpg',
                            'urlMobile': {
                                'default': 'https://dummyimage.com/100/ff0000/000000.jpg',
                                'highRes': 'https://dummyimage.com/200/008000/c3c3c3.jpg',
                            },
                            'urlApp': 'https://dummyimage.com/100/ffa500/000000.jpg',
                            'urlTabletApp': 'https://dummyimage.com/100/800080/fff.jpg',
                        },
                    },
                    'cta': [
                        {
                            'type': 'primary',
                            'text': 'zum Vergleich',
                            'urlDesktop': 'primary URL urlDesktop',
                            'urlMobile': 'primary URL urlMobile',
                        },
                    ],
                    'urlDelete': 'https://delete promo tile URL',
                },
            ],
        };

        oIpss.bind('rlv', sRlvApiUrl, $('.mod24ac.rlv'));
    });
})();
